import task from "@commons/task";
//import itiRegisterDual from "./itiRegisterDual";
import itiRegisterDual from "./iti/itiRegisterDual";

var inputDateFormat = "L";//"DD/MM/YYYY";

//Date picker Registration------------------------------------------
if ($(".birthDate").length) {
    $(".birthDate").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: inputDateFormat,
        maxDate: new Date(),
        yearRange: "-100:+0",
        defaultDate: moment().subtract(1, 'years').toDate()
    });
}


if ($(".licenceReleaseDate").length) {
    $(".licenceReleaseDate").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: inputDateFormat,
        maxDate: new Date(),
        yearRange: "-80:+0",
        defaultDate: moment().subtract(1, 'years').toDate()
    });
}

if ($(".licenceExpirationDate").length) {
    $(".licenceExpirationDate").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: inputDateFormat,
        minDate: new Date(),
        yearRange: "0:+50"
    });
}

//Only on account
if ($(".identityCardReleaseDate").length) {
    $(".identityCardReleaseDate").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: "L",
        maxDate: new Date(),
        yearRange: "-80:+0",
        defaultDate: moment().subtract(1, 'years').toDate()
    });
}

if ($(".identityCardExpirationDate").length) {
    $(".identityCardExpirationDate").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: inputDateFormat,
        minDate: new Date(),
        yearRange: "0:+50"
    });
}

$(".local-complete select.country, .local-complete-cn select.country").each(function (index) {
    $(this).select2({
        theme: 'bootstrap4',
        width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
        placeholder: $(this).data('placeholder'),
        allowClear: Boolean($(this).data('allow-clear')),
        closeOnSelect: !$(this).attr('multiple')
    });
});

if ($(".iti-dual").length) {
    itiRegisterDual($(".iti-dual"));
}

// Autocomplete----------------------------------------------------------
var EGON_BASE_LTS_URL = task("Sv.egonLst") + "&";
var EGON_BASE_NORM_URL = task("Sv.egonNorm") + "&";

var EGON_BASE_LSTLCN_URL = task("Sv.egonLstLcn") + "&";

// Versione generica con indirizzo----------------------------------------------
$(".local-complete").each(function (i) {
    var country = $(".country", this);
    var town = $(".town", this);
    var province = $(".province", this);
    var address = $(".address", this);
    var postalCode = $(".postalCode", this);
    var buildingNumber = $(".addressNumber", this);

    var provinceAlwaysEditable = $(province).hasClass("province-editable");

    function isITA() {
        return ($(country, "option:selected").val().toUpperCase() === "IT");
    }

    $(country).on('change', function () {
        $(town).val("");
        $(province).val("");

        if ($(address).length) {
            $(address).val("");
            $(postalCode).val("");
            $(buildingNumber).val("");
        }

        if (isITA()) {
            $(town).autocomplete("enable");
            $(town).attr('role', 'combobox').attr('aria-autocomplete', 'list');

            $(province).closest("div").show().attr('aria-hidden', 'false');
            $(province).attr("readonly", true);

            if ($(address).length) {
                $(address).autocomplete("enable").closest("div").show();
                $(address).attr('role', 'combobox').attr('aria-autocomplete', 'list');

                //$(postalCode).closest("div").show();
                $(postalCode).attr("readonly", true);
                $(buildingNumber).closest("div").show();
            }

        } else {//No IT                    
            $(town).autocomplete("disable");
            $(town).removeAttr('role').removeAttr('aria-autocomplete');

            if (!provinceAlwaysEditable) {
                $(province).closest("div").hide().attr('aria-hidden', 'true');
                $(province).attr("readonly", true);
            } else {
                $(province).closest("div").show().attr('aria-hidden', 'false');
                $(province).attr("readonly", false);
            }

            if ($(address).length) {
                $(address).autocomplete("disable");
                $(address).removeAttr('role').removeAttr('aria-autocomplete');

                //$(postalCode).closest("div").hide();
                $(postalCode).attr("readonly", false);
            }
        }

    });

    //Autocomplete comune
    $(town).autocomplete({//attivo solo per ita
        dataType: "json",
        minLength: 2,
        delay: 500,
        source: function (request, response) {
            $(town).attr('aria-busy', 'true');

            $.ajax({
                url: EGON_BASE_LTS_URL + 'LST=LstCnl&NR9CND=15&WPXISO=ITA&FLXDSXDPT=2&DSXCNL=' + $.trim(request.term),
                dataType: "json",
                success: function (data) {// Creazione lista comuni

                    var realArray = [];
                    var CNL = data.CNL_AREA_OUT.CNL;
                    if (CNL[0] !== null) {
                        var realArray = $.makeArray(CNL);
                    }

                    realArray = realArray.slice(0, 15);//limit result

                    response($.map(realArray, function (value, key) {
                        return{
                            label: value.DSXOBJCNL + " (" + value.DSXOBJDPT + ")",
                            value: value.DSXOBJCNL + "|" + value.DSXOBJDPT + "|" + value.DSXOBJREG
                        };
                    }));
                },
                complete: function () {
                    $(town).attr('aria-busy', 'false');
                }
            });
        },
        select: function (e, ui) {//Selezione elemento dalla lista
            e.preventDefault();

            var valuesArray = ui.item.value.split("|");//comune|provincia(sigla)|regione
            $(town).val(valuesArray[0]);
            $(province).val(valuesArray[1]);

            if ($(address).length) {
                $(address).val("");
                $(postalCode).val("");
                $(buildingNumber).val("");
            }

        },
        focus: function (event, ui) {
            event.preventDefault();
            $(town).val(ui.item.value.split("|")[0]);
        },
        change: function (event, ui) {

            if (ui.item === null || ui.item === undefined) {

                $(town).val("");
                $(province).val("");

                if ($(address).length) {
                    $(address).val("");
                    $(postalCode).val("");
                    $(buildingNumber).val("");
                }
            }
        },
        position: {
            collision: "flip"
        }
    }).attr('autocomplete', 'new-town');

    //Autocomplete indirizzo        
    $(address).autocomplete({
        dataType: "json",
        minLength: 2,
        delay: 500,
        source: function (request, response) {
            $(address).attr('aria-busy', 'true');

            $.ajax({
                url: EGON_BASE_LTS_URL + 'LST=LstStr&NR9CND=10&WPXISO=ITA&DSXSTA=ITALIA&DSXDPT=' + $.trim($(province).val()) + "&DSXCNL=" + $.trim($(town).val()) + "&DSXST1=" + $.trim(request.term),
                dataType: "json",
                success: function (data) {// Creazione lista strade
                    var realArray = [];
                    var STR = data.STR_AREA_OUT.STR;
                    if (STR[0] !== null) {
                        var realArray = $.makeArray(STR);
                    }

                    realArray = realArray.slice(0, 15);//limit result

                    response($.map(realArray, function (value, key) {
                        return{
                            label: value.DSXSYN + ((value.CDXZIP === "") ? "" : " (" + value.CDXZIP + ")"), value: value.DSXSYN + "|" + value.CDXZIP
                        };
                    }));
                },
                complete: function () {
                    $(address).attr('aria-busy', 'false');
                }
            });
        },
        select: function (e, ui) {//Selezione elemento dalla lista
            e.preventDefault();

            var valuesArray = ui.item.value.split("|");//via|cap
            $(address).val(valuesArray[0]);
            $(postalCode).val(valuesArray[1]);

            if (valuesArray[1] !== "") {// Via Multicap
                $(postalCode).attr("readonly", true);
            } else {
                $(postalCode).attr("readonly", false);
            }

            $(buildingNumber).val("");

        },
        focus: function (event, ui) {
            event.preventDefault();
            $(address).val(ui.item.value.split("|")[0]);
        },
        change: function (event, ui) {
            if (ui.item === null || ui.item === undefined) {
                $(address).val("");
                $(postalCode).val("");
                $(buildingNumber).val("");
            }
        },
        position: {
            collision: "flip"
        }
    }).attr('autocomplete', 'new-address');


    //Normalizzazione aggiungiva per multicap
    $(buildingNumber).on('keyup', function () {

        var bn = $.trim($(this).val());

        if (bn === "" || $(postalCode).attr("readonly") || !isITA()) {
            return;
        }

        if ($(town).val() !== "" && $(province).val() !== "" && $(address).val() !== "") {
            var bn_n = bn.replace(/\D/g, '');// remove char;
            if (bn_n === "") {
                $(postalCode).val("");
                return;
            }

            var url = EGON_BASE_NORM_URL + "DSXCNY=ITA";
            url += "&DSXDPT=" + $(province).val();
            url += "&DSXCNL=" + $(town).val();
            url += "&DSXVIA=" + $(address).val() + " " + bn_n;
            $.getJSON(url, function (data) {
                try {
                    /*if (data.SOG_INR[0].INR_620_S.CDXZIP) {
                     $(postalCode).val(data.SOG_INR[0].INR_620_S.CDXZIP);
                     }*/
                    if (data.SOG[0].INR_620.CDXZIP) {
                        $(postalCode).val(data.SOG[0].INR_620.CDXZIP);
                    }
                } catch (err) {

                }
            });
        }
    });

    //Restore autocomplete form state
    if (isITA()) {
        $(town).attr('role', 'combobox').attr('aria-autocomplete', 'list');

        if ($.trim($(province).val()) === "" || $.trim($(town).val()) === "") {
            $(province).val("");
            $(town).val();
        }

        $(province).attr("readonly", true);
        if ($(address).length) {
            $(address).attr('role', 'combobox').attr('aria-autocomplete', 'list');
            $(postalCode).attr("readonly", true);
        }

        // verifico se i dati inserito sono di un multicap
        if ($.trim($(town).val()) !== "" && $.trim($(province).val()) !== "" && $.trim($(address).val()) !== "") {
            var urls = EGON_BASE_LTS_URL + 'LST=LstStr&NR9CND=10&WPXISO=ITA&DSXSTA=ITALIA'
                    + "&DSXDPT=" + $.trim($(province).val())
                    + "&DSXCNL=" + $.trim($(town).val())
                    + "&DSXST1=" + $.trim($(address).val());

            $.get(urls, function (data) {
                try {
                    var STR = data.STR_AREA_OUT.STR;
                    if (STR[0] !== null) {
                        $.each(STR, function (index, item) {
                            if (item.DSXSYN === $(address).val() && item.CDXZIP === "") {
                                $(postalCode).attr("readonly", false);
                            }
                        });
                    }
                } catch (err) {

                }
            });

        }

    } else {//no it

        if (!provinceAlwaysEditable) {
            $(province).closest("div").hide().attr('aria-hidden', 'true');
            $(province).attr("readonly", true);
        } else {
            $(province).closest("div").show().attr('aria-hidden', 'false');
            $(province).attr("readonly", false);
        }

        $(town).autocomplete("disable");
        $(town).removeAttr('role').removeAttr('aria-autocomplete');

        if ($(address).length) {
            $(address).autocomplete("disable");
            $(address).removeAttr('role').removeAttr('aria-autocomplete');

            //$(postalCode).closest("div").hide();
            $(postalCode).attr("readonly", false);
        }
    }

    //KEY improve
    $(this).find(".town,.address").keydown(function (event) {
        var newEvent = $.Event('keydown', {
            keyCode: event.keyCode
        });
        if (newEvent.keyCode !== $.ui.keyCode.TAB) {
            return;
        }

        newEvent.keyCode = $.ui.keyCode.DOWN;
        $(this).trigger(newEvent);
        newEvent.keyCode = $.ui.keyCode.ENTER;
        $(this).trigger(newEvent);
    });

});


// Versione comnuni di nascita--------------------------------------------------
$(".local-complete-cn").each(function (i) {
    var country = $(".country", this);
    var town = $(".town", this);
    var province = $(".province", this);

    function isITA() {
        return ($(country, "option:selected").val().toUpperCase() === "IT");
    }

    $(country).on('change', function () {
        $(town).val("");
        $(province).val("");

        if (isITA()) {
            $(town).autocomplete("enable");
            $(town).attr('role', 'combobox').attr('aria-autocomplete', 'list');

            $(province).closest("div").show().attr('aria-hidden', 'false');
        } else {//No IT                    
            $(town).autocomplete("disable");
            $(town).removeAttr('role').removeAttr('aria-autocomplete');

            $(province).closest("div").hide().attr('aria-hidden', 'true');
        }
    });

    $(town).autocomplete({//attivo solo per ita
        dataType: "json",
        minLength: 2,
        delay: 500,
        source: function (request, response) {
            $(town).attr('aria-busy', 'true');

            $.ajax({
                url: EGON_BASE_LSTLCN_URL + 'LST=LstLcn&TPXFUN=VISUFF&WPXISO=ITA&DSXOBJ=' + $.trim(request.term),
                dataType: "json",
                success: function (data) {// Creazione lista comuni

                    var realArray = [];
                    if (
                            data.hasOwnProperty("LOC_CF_AREA_OUT") &&
                            data.LOC_CF_AREA_OUT.hasOwnProperty("LOC_CF") &&
                            data.LOC_CF_AREA_OUT.LOC_CF.length &&
                            data.hasOwnProperty("LSTERR") &&
                            data.LSTERR.hasOwnProperty("WP9STC") &&
                            data.LSTERR.WP9STC.hasOwnProperty("lValue") &&
                            !data.LSTERR.WP9STC.lValue
                            ) {
                        var realArray = $.makeArray(data.LOC_CF_AREA_OUT.LOC_CF);
                    }

                    realArray = realArray.filter(function (el) {
                        return el.DSXOBJDPT !== "EE";// Tolgo comuni esteri
                    });

                    realArray = realArray.slice(0, 15);//limit result
                    //console.log(realArray);

                    response($.map(realArray, function (value, key) {
                        return{
                            label: value.DSXOBJ.toUpperCase() + " (" + value.DSXOBJDPT + ")",
                            value: value.DSXOBJ.toUpperCase() + "|" + value.DSXOBJDPT
                        };
                    }));
                },
                complete: function () {
                    $(town).attr('aria-busy', 'false');
                }
            });
        },
        select: function (e, ui) {//Selezione elemento dalla lista
            e.preventDefault();

            var valuesArray = ui.item.value.split("|");//comune|sigla provincia
            $(town).val(valuesArray[0]);
            $(province).val(valuesArray[1]);
        },
        focus: function (event, ui) {
            event.preventDefault();
            $(town).val(ui.item.value.split("|")[0]);
        },
        change: function (event, ui) {
            if (ui.item === null || ui.item === undefined) {

                $(town).val("");
                $(province).val("");
            }
        },
        position: {
            collision: "flip"
        }
    }).attr('autocomplete', 'new-town');

    //Restore autocomplete form state
    if (isITA()) {
        $(town).attr('role', 'combobox').attr('aria-autocomplete', 'list');
        if ($.trim($(province).val()) === "" || $.trim($(town).val()) === "") {
            $(province).val("");
            $(town).val();
        }
    } else {//no it
        $(province).closest("div").hide().attr('aria-hidden', 'true');
        $(town).autocomplete("disable");
        $(town).removeAttr('role').removeAttr('aria-autocomplete');
    }

    //KEY improve
    $(this).find(".town").keydown(function (event) {
        var newEvent = $.Event('keydown', {
            keyCode: event.keyCode
        });
        if (newEvent.keyCode !== $.ui.keyCode.TAB) {
            return;
        }

        newEvent.keyCode = $.ui.keyCode.DOWN;
        $(this).trigger(newEvent);
        newEvent.keyCode = $.ui.keyCode.ENTER;
        $(this).trigger(newEvent);
    });

});


// Modo di pagamento----------------------------------------------------------
$(".payment-mode").each(function (index) {
    var select = $(".paymentType", this);
    var wallet = $(".paymentPrepaidWallet", this);
    var bankCode = $(".paymentBankCode", this);
    var rid = $(".paymentRid", this);
    var payBtn = $(".paymentCardButton", this);// Puo non esserci

    function showBankCode(onChange) {
        var payType = $(select).val().toUpperCase();

        if (onChange) {
            $(wallet).find("span.cp-fe-msg").hide();
            $(bankCode).find("span.cp-fe-msg").hide();
            $(rid).find("span.cp-fe-msg").hide();
        }

        switch (payType) {
            case "BANK_TRANSFER":
                $(bankCode).show().attr('aria-hidden', 'false');
                $(rid).hide().attr('aria-hidden', 'true').find("input").val("");
                $(wallet).hide().attr('aria-hidden', 'true');
                $(payBtn).hide().attr('aria-hidden', 'true');
                break;
            case "RID":
                $(bankCode).show().attr('aria-hidden', 'false');
                $(rid).show().attr('aria-hidden', 'false');
                $(wallet).hide().attr('aria-hidden', 'true');
                $(payBtn).hide().attr('aria-hidden', 'true');
                break;
            case "CREDIT_CARD":
                $(bankCode).hide().attr('aria-hidden', 'true').find("input").val("");
                $(rid).hide().attr('aria-hidden', 'true').find("input").val("");
                $(wallet).show().attr('aria-hidden', 'false');
                $(payBtn).show().attr('aria-hidden', 'false');
                break;
        }
    }

    $(select).change(function () {
        showBankCode(true);
    });

    showBankCode(false);
});

// In modifica form locked------------------------------------------------------
$(".user-logged .form-locked").each(function (index) {
    $(':input', $(this)).each(function (index) {
        if (!$(this).closest(".user-doc-upload-btn").length && !$(this).closest(".form-unlock-area").length) {
            $(this).addClass("disabled").prop("disabled", true);
        }
    });
});

// General spin btn form------------------------------------------------------
$("form").submit(function (e) {
    $(".btn-with-spinner", this).addClass("spin");
});

// Campi Opzionali------------------------------------------------------

if ($(".birthCountry").length) {
    function birthCountryChange() {
        /*$(".form-mark-fiscalCode").toggle(
         $.inArray($(".birthCountry").val(), ["CH", "FR"]) === -1
         );*/
        $(".form-mark-fiscalCode").toggle($(".birthCountry").val() === "IT");
        //$(".form-mark-fiscalCode").toggle($(".birthCountry").val() !== "CH");
    }

    $(".birthCountry").on("change", function () {
        birthCountryChange();
    });

    birthCountryChange();
}

if ($(".licenceCountry").length) {
    function licenceCountryChange() {
        //$(".form-mark-expirationDate").toggle($(".licenceCountry").val() !== "CH");
        $(".form-mark-expirationDate").toggle($(".licenceCountry").val() === "IT");
    }

    $(".licenceCountry").on("change", function () {
        licenceCountryChange();
    });

    licenceCountryChange();
}


if ($("#groupId").length) {

    function showRequirementsForGroup() {
        var groupId = $("#groupId").val();
        $(".group-requirements > .grup-bound").hide().attr('aria-hidden', 'true');
        if (!groupId) {
            return;
        }
        $(".group-requirements > .grup-bound-" + groupId).show().attr('aria-hidden', 'false');
    }

    $("#groupId").on("change", function () {
        showRequirementsForGroup();
    });

    showRequirementsForGroup();

    $(".group-requirements .user-group-field").each(function (index) {
        var type = $(this).data("type");
        switch (type) {
            case "DATE":
                $(this).datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: inputDateFormat
                });
                break;
            default:
                break;
        }

    });
}


//TODO spostare in commons as helper
$(".optionalChkGroup").each(function (index) {
    var t = this;
    var targetGroup = "." + $(this).data("targets");

    function updateChkGroup(onChange) {
        $(targetGroup).each(function (index) {
            var onchecked = $(this).data("onchecked");
            if ($(t).is(':checked') !== (onchecked === "close")) {
                $(this).slideDown();
                $(t).attr('aria-expanded', 'true');
                $(".display-required", $(this)).prop('required', true);
            } else {
                if (onChange) {
                    $(this).slideUp();
                } else {
                    $(this).hide();
                }
                $(t).attr('aria-expanded', 'false');
                $(".display-required", $(this)).prop('required', false).blur();
            }
        });
    }

    $(t).change(function () {
        updateChkGroup(true);
    });
    updateChkGroup(false);

});